(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('PremiumAccreditationInformation', [
			'$timeout',
			'$window',
			'APP_BASE_PATH',
			'ServiceLevelFactory',
			'SettingsFactory',
			'urlFactory',
			PremiumAccreditationInformationFunction
		]);

	function PremiumAccreditationInformationFunction(
		$timeout,
		$window,
		APP_BASE_PATH,
		ServiceLevelFactory,
		SettingsFactory,
		urlFactory) {

		var premiumAccreditationInformation = this;
		var nextServiceLevelName = 'PREMIUM';

		function updateAccreditationInformation() {
			var accreditationStatusForm = angular.extend({}, premiumAccreditationInformation.serializedForm);

			SettingsFactory.accreditation.update(accreditationStatusForm);
		}

		function performServiceLevelUpgradeAndRedirectToSuccess() {
			ServiceLevelFactory.upgradeServiceLevelAndRiaPlan(nextServiceLevelName, premiumAccreditationInformation.riaPlanId)
				.then(function() {
					urlFactory.redirect('/account/upgrade/premium/success');
				});
		}

		premiumAccreditationInformation.updateValidation = function() {
			if(premiumAccreditationInformation.serializedForm.accredited) {
				if(premiumAccreditationInformation.serializedForm.gt1MillionNetWorth ||
					premiumAccreditationInformation.serializedForm.gt200kSalary ||
					premiumAccreditationInformation.serializedForm.gt300kJointIncome ||
					premiumAccreditationInformation.serializedForm.businessRepresentative) {
					premiumAccreditationInformation.form.accredited.$setValidity("noqualificationsselected", true);
				} else {
					premiumAccreditationInformation.form.accredited.$setValidity("noqualificationsselected", false);
				}
			} else {
				premiumAccreditationInformation.serializedForm.gt1MillionNetWorth = false;
				premiumAccreditationInformation.serializedForm.gt200kSalary = false;
				premiumAccreditationInformation.serializedForm.gt300kJointIncome = false;
				premiumAccreditationInformation.serializedForm.businessRepresentative = false;
				premiumAccreditationInformation.form.accredited.$setValidity("noqualificationsselected", true);
			}
		};

		premiumAccreditationInformation.handleContinue = function() {
			updateAccreditationInformation();
			if(premiumAccreditationInformation.reitInvestmentOrderGroupId) {
				$timeout(function() {
					$window.document.getElementById('additional-investment-form').submit();
				});
			} else {
				performServiceLevelUpgradeAndRedirectToSuccess();
			}
		};

		premiumAccreditationInformation.$onInit = function() {
			angular.extend(premiumAccreditationInformation, globalConfig);

			if(premiumAccreditationInformation.reitInvestmentOrderGroupId) {
				premiumAccreditationInformation.backLink = APP_BASE_PATH + '/account/repeat-investment/start';
			} else {
				premiumAccreditationInformation.backLink = APP_BASE_PATH + '/account/upgrade/premium';
			}
		};
	}
})(window.angular);